import { render, staticRenderFns } from "./DeviceType.vue?vue&type=template&id=0816ddda&scoped=true&"
import script from "./DeviceType.vue?vue&type=script&lang=js&"
export * from "./DeviceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816ddda",
  null
  
)

export default component.exports